/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner } from './get-slack-evidence-reminder200-response-inner-settings-inner-reminders-inner';

/**
 * 
 * @export
 * @interface GetSlackEvidenceReminder200ResponseInnerSettingsInner
 */
export interface GetSlackEvidenceReminder200ResponseInnerSettingsInner {
    /**
     * 
     * @type {string}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInner
     */
    'notificationScope': GetSlackEvidenceReminder200ResponseInnerSettingsInnerNotificationScopeEnum;
    /**
     * 
     * @type {Array<GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner>}
     * @memberof GetSlackEvidenceReminder200ResponseInnerSettingsInner
     */
    'reminders': Array<GetSlackEvidenceReminder200ResponseInnerSettingsInnerRemindersInner>;
}

export const GetSlackEvidenceReminder200ResponseInnerSettingsInnerNotificationScopeEnum = {
    thisMonth: 'THIS_MONTH',
    prevMonth: 'PREV_MONTH'
} as const;

export type GetSlackEvidenceReminder200ResponseInnerSettingsInnerNotificationScopeEnum = typeof GetSlackEvidenceReminder200ResponseInnerSettingsInnerNotificationScopeEnum[keyof typeof GetSlackEvidenceReminder200ResponseInnerSettingsInnerNotificationScopeEnum];


